import { END_POINTS } from "@/constants/url";
import emptySplitApi from "@/lib/rtk";
import { CommonResponseType } from "@/types/General";

export const homeService = emptySplitApi.injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({
    getCart: builder.query<
      CommonResponseType & { data: any },
      { type: string }
    >({
      query: ({ type }) => ({
        url: `${END_POINTS.getCart}?type=${type}`,
        method: "GET",
      }),
      providesTags: ["CART"],
    }),

    addToCart: builder.mutation<
      CommonResponseType & { data: any },
      {
        product_id: number | string;
        variation_id?: number | string | null;
        qty: number;
        store_id: number | string;
        channel?: string;
      }
    >({
      query: (data) => {
        const body: any = {
          product_id: Number(data.product_id),
          variation_id: data.variation_id ? Number(data.variation_id) : null,
          qty: Number(data.qty),
          store_id: Number(data.store_id),
          channel: data.channel || "normal",
        };
        return {
          url: `${END_POINTS.addToCart}`,
          method: "POST",
          body,
        };
      },
      invalidatesTags: ["CART"],
    }),

    placeOrder: builder.mutation<CommonResponseType & { data: any }, any>({
      query: (body) => ({
        url: `${END_POINTS.placeOrder}`,
        method: "POST",
        body,
      }),
      invalidatesTags: ["CART", "ORDERS"],
    }),

    removeFromCart: builder.mutation<
      CommonResponseType & { data: any },
      { cart_id: number | string }
    >({
      query: (data) => {
        return {
          url: `${END_POINTS.removeFromCart}/${data.cart_id}`,
          method: "DELETE",
        };
      },
      invalidatesTags: ["CART"],
    }),

    getCouponList: builder.query<
      CommonResponseType & { data: any },
      { search?: string; type?: string }
    >({
      query: (params) => ({
        url: `${END_POINTS.getCouponList}`,
        method: "GET",
        params,
      }),
    }),

    applyCoupon: builder.mutation<
      CommonResponseType & { data: any },
      { coupon_code: string; type: string }
    >({
      query: (body) => ({
        url: `${END_POINTS.applyCoupon}`,
        method: "POST",
        body,
      }),
      invalidatesTags: ["CART"],
    }),

    removeCoupon: builder.mutation<
      CommonResponseType & { data: any },
      { id: number | string }
    >({
      query: (data) => ({
        url: `${END_POINTS.removedCoupon}/${data.id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["CART"],
    }),

    verifyPayment: builder.mutation<
      CommonResponseType & { data: any },
      { razorpay_order_id: string | number; razorpay_payment_id: string; razorpay_signature?: string }
    >({
      query: (body) => ({
        url: END_POINTS.verifyPayment,
        method: "POST",
        body,
      }),
      invalidatesTags: ["ORDERS"],
    }),
  }),
});

export const {
  useGetCartQuery,
  useAddToCartMutation,
  usePlaceOrderMutation,
  useRemoveFromCartMutation,
  useGetCouponListQuery,
  useApplyCouponMutation,
  useRemoveCouponMutation,
  useVerifyPaymentMutation,
} = homeService;
